import { useQuery } from '@tanstack/react-query';
import { useUserManagementClientContext } from './UserManagementClientContext';

export const getManagedAccountsQueryKey = ['getManagedAccounts'];

export const useGetManagedUsers = () => {
  const client = useUserManagementClientContext();

  return useQuery({
    queryKey: getManagedAccountsQueryKey,
    queryFn: client.getManagedAccounts,
  });
};
